module.exports = __webpack_public_path__ + "img/teknik.87b87d62.png";